import { Avatar } from "@mui/material";
import React, { useState } from "react";
import { CgSpinnerTwo } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";

import CandidateDetailSkeleton from "./CandidateDetailSkeleton";
import { resendComplianceNotificationToCandiate } from "../../../../../../reducers/clientcandidatedetail";
import CandidateConditionTags from "../../CandidateConditionTags";
import GenderIcon from "../../GenderIcon";

const CandidateRightBasicInfo = () => {
  const { clientUserAllPermissions } = useSelector((state) => state.session);
  const { candidateDetails, candidateDetLoading } = useSelector(
    (state) => state.clientCandidateDetail,
  );
  const { isPremiumAccount } = useSelector((state) => state.session);

  const { user } = useSelector((state) => state.clientProfile);
  const [reminderLoading, setReminderLoading] = useState(false);
  const dispatch = useDispatch();

  const {
    candidate_id,
    nmc_gmc_conditions,
    dbs_conditions,
    visa_restrictions,
    is_bank_candidate,
    profile_percent,
  } = candidateDetails;

  // Handlers
  const handleReminderClick = () => {
    dispatch(
      resendComplianceNotificationToCandiate({
        candidate_id,
        loading: reminderLoading,
        setLoading: setReminderLoading,
      }),
    );
  };

  const canShowReminderButton =
    isPremiumAccount &&
    user.is_bank_client &&
    is_bank_candidate &&
    profile_percent !== 100;

  return (
    <div className="CandiateRightBasicInfo_wrapper">
      <div
        className={`LeftBasicInfo_Wrapper flex max-w-full flex-col gap-4 sm:flex-row sm:justify-between`}
      >
        {/* left side- candidate details */}
        <div className={`px-4`}>
          {candidateDetLoading ? (
            <CandidateDetailSkeleton.candidateBasicInfo />
          ) : (
            <div className="flex items-center gap-4">
              <div className="relative flex flex-col items-center gap-1">
                <div className="relative">
                  <Avatar
                    alt={candidateDetails?.candidate_name}
                    src={candidateDetails?.profile_image}
                    sx={{ width: 90, height: 90 }}
                  />
                </div>
                <div className="d-flex items-end justify-end">
                  {/* <GenderIcon gender={candidateDetails?.candidate_gender} /> */}
                </div>
              </div>
              <div className="grid justify-between gap-1">
                <div
                  className={`relative grid grid-cols-1 items-end gap-2 sm:grid-cols-[1fr_200px] sm:gap-5`}
                >
                  <div>
                    <h5 className="flex items-center gap-1 text-sm font-semibold leading-[normal] text-txtColor">
                      <span className="flex items-center gap-2">
                        {candidateDetails?.candidate_name}
                        {candidateDetails?.candidate_gender && (
                          <GenderIcon
                            gender={candidateDetails.candidate_gender}
                          />
                        )}
                      </span>
                    </h5>
                  </div>
                </div>

                <div
                  className={`grid grid-cols-1 items-end gap-2 sm:grid-cols-[1fr_203px] sm:gap-5`}
                >
                  <div className="flex items-center gap-2">
                    <span className="!text-[12px] font-medium text-txtColor">
                      {candidateDetails?.role_name}
                    </span>
                    {/* <GenderIcon gender={candidateDetails?.candidate_gender} /> */}
                  </div>

                  <div></div>
                </div>

                <div>
                  {nmc_gmc_conditions || dbs_conditions || visa_restrictions ? (
                    <>
                      <CandidateConditionTags
                        nmc_gmc_conditions={nmc_gmc_conditions}
                        dbs_conditions={dbs_conditions}
                        visa_restrictions={visa_restrictions}
                      />
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          )}
        </div>
        {/* right side- compliance button */}
        {canShowReminderButton ? (
          <div>
            <button
              className={`!font-sm rounded-lg border border-primary bg-lightblue px-4 py-2 font-semibold text-primary ${reminderLoading ? "cursor-not-allowed" : ""}`}
              onClick={handleReminderClick}
            >
              {reminderLoading ? (
                <div className="flex items-center justify-center">
                  <CgSpinnerTwo className="buttonLoader animate-spin" />
                  <span className="ml-2">Sending Compliance Reminder</span>
                </div>
              ) : (
                "Send Compliance Reminder"
              )}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CandidateRightBasicInfo;
